<script>
  import { players } from "../general/store/index.js";
  const names = $players;
  const numberOfPlayers = names.length;
  let round = 0;
  let currentRound = new Array(numberOfPlayers).fill(3);
  let score = Array.from(Array(numberOfPlayers), () => new Array());

  function nextRound() {
    currentRound.forEach((value, index) => {
      score[index] = [...score[index], value];
    });
    round++;
    currentRound = new Array(numberOfPlayers).fill(round);
  }
</script>

<style>
  button.full {
    width: 100%;
  }
</style>

<div class="columns">
  {#each { length: numberOfPlayers } as name, index}
    <div class="column has-text-centered">
      <span class="has-text-weight-bold is-size-4">
        {names[index]} ({score[index].reduce((a, b) => a + b, 0)})
      </span>
    </div>
  {/each}
</div>

{#each { length: round } as round, i}
  <div class="columns">
    {#each { length: numberOfPlayers } as playerId, index}
      <div class="column has-text-centered">
        <span class="has-text-weight-bold ">{score[index][i]}</span>
      </div>
    {/each}
  </div>
{/each}

<div class="columns">
  {#each currentRound as round}
    <div class="column">
      <div class="control">
        <input class="input" type="number" bind:value={round} />
      </div>
    </div>
  {/each}
</div>

<hr />
<div class="columns">
  <div class="column is-full">
    <button class="button is-info full is-size-5" on:click={nextRound}>
      next round
    </button>
  </div>
</div>
